import { useDroppable } from "@dnd-kit/core";
import { cn } from "@/lib/utils";

interface DroppableColumnProps {
  id: string;
  isValidTarget: boolean;
  children: React.ReactNode;
}

const DroppableColumn: React.FC<DroppableColumnProps> = ({
  id,
  isValidTarget,
  children,
}) => {
  const { setNodeRef, isOver } = useDroppable({
    id,
    disabled: !isValidTarget,
  });

  return (
    <section
      ref={setNodeRef}
      className={cn(
        "flex flex-col min-h-0 bg-muted/30 rounded-xl border-2 overflow-hidden transition-colors",
        isOver && isValidTarget
          ? "border-primary bg-primary-light/40"
          : "border-border",
      )}
    >
      {children}
    </section>
  );
};

export default DroppableColumn;
